
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../components/utils/utils';


class ModalAlert extends React.Component {
  state = {
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
  }

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
      };
    }
    this.setState({ colors, sourceStyle, style });
  }

  render() {
    const {
      title,
      bodyText,
      disableButton,
      name,
      onHide,
      buttonText,
      ...rest
    } = this.props;

    return (
      <Modal {...rest} style={{
          ...(this.props.fontSize && { fontSize: this.props.fontSize + 'rem' })
        }}>
        <Modal.Header style={this.state.style}>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={this.state.style}>
          {bodyText}
          <br /><br />

          {!disableButton && (
            <Button
              className="btn btn-primary pull-right"
              style={{ color: 'white' }}
              onClick={() => onHide(name)}
            >
              {buttonText || 'Zamknij'}
            </Button>
          )}

          <br /><br />
        </Modal.Body>
      </Modal>
    );
  }

}

const mapState = (state) => ({
  fontSize: state.runtime.fontSize,
});

export default (connect(mapState)(ModalAlert));


// WEBPACK FOOTER //
// src/routes/eservices/ModalAlert.js